import { SVGIconComponent } from './types';

export const ActionOpen: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Action/Open" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M6.47396578,3.00000172 C6.22162677,2.99913446 6.00018193,3.3264395 6.00018193,3.61118206 L6.00018193,18.6475095 C6.00018193,18.9730566 6.28857879,19.1015597 6.58383125,19.2309073 C9.43264291,20.4784451 15.1326833,22.9744315 15.1326833,22.9744315 C15.4279577,23.1037857 15.709477,22.7165808 15.709477,22.3910337 L15.709477,19.2586882 L18.1539837,19.2586882 C19.2277429,19.2586882 20.117829,18.3653673 20.117829,17.279314 L20.117829,4.99329028 C20.117829,3.90723699 19.2277429,3.00695977 18.1539837,3.00695977 C17.2304326,3.00695977 10.3680375,3.00348605 6.47396578,3.00000172 L6.47396578,3.00000172 Z M9.49526622,4.29876912 L18.1539837,4.29876912 C18.5427976,4.29876912 18.8406429,4.60002462 18.8406429,4.99329028 L18.8406429,17.279314 C18.8406429,17.6725796 18.5427976,17.966901 18.1539837,17.966901 L15.709477,17.966901 L15.709477,7.35461776 C15.709477,7.02907069 15.4279577,6.90056761 15.1326833,6.77121999 L9.49526622,4.29876912 Z"
        id="icon-open-locker"
        fill="#848484"
      ></path>
    </g>
  </svg>
);
